import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { GetConsulteeTeamsRequest } from 'types';
import { API_QUERY_KEYS, getFilterTeams, QueryDefaults } from 'api';
import { GetAllTeamsResponse } from '../types';

export const useManageAllTeams = (
  request?: GetConsulteeTeamsRequest
): QueryObserverResult<GetAllTeamsResponse> =>
  useQuery(
    [API_QUERY_KEYS.getAllTeams, request],
    () => getFilterTeams(request),
    QueryDefaults
  );
